<template>
  <PencilEdit
    :fieldLabel="$t('project.dlpDate')"
    :displayValue="dlpDateFieldTools.displayField.value"
    :canEdit="dlpDateFieldTools.canEdit.value"
    @closePencil="dlpDateFieldTools.updateFc"
    @openPencil="updateDatePickerValue"
  >
    <DatePicker
      :disabled="disableDlpdDate"
      :calendarButton="true"
      calendarButtonIcon="fa fa-calendar"
      :value="datePickerValue"
      @selected="val => dlpDateFieldTools.setPendingField(val)"
    />
  </PencilEdit>
</template>

<script>
import _ from 'lodash'
import { computed } from '@vue/composition-api'

import DatePicker from '@/controls/DatePicker'
import PencilEdit from '@/controls/PencilEdit'
import dateUtil from '@/utils/dateUtil'
import { fieldTypes, isProjectPic, projectFieldEdit } from './projectInfo'
import { projectStatus } from '@/utils/locale'
import { useStoreGetters } from '@/store'

export default {
  components: {
    DatePicker,
    PencilEdit,
  },
  setup () {
    const { currentProject } = useStoreGetters('projects', ['currentProject'])
    const curDlpDate = computed(() => _.get(currentProject.value, 'dlpDate'))
    const disableDlpdDate = computed(() => {
      if (_.isEmpty(curDlpDate.value)) return undefined
      const yesterday = dateUtil.toMoment(new Date()).subtract(1, 'day').toDate()
      return { from: undefined, to: yesterday }
    })
    const dlpDateFieldTools = projectFieldEdit('dlpDate', [projectStatus.DRAFT, projectStatus.ACTIVE, projectStatus.COMPLETED], isProjectPic, fieldTypes.DATE)
    const actualCompDate = computed(() => _.get(currentProject.value, 'actualCompDate'))
    const updateDatePickerValue = () => {
      if (!_.isEmpty(actualCompDate.value) && _.isEmpty(curDlpDate.value)) {
        const targetDate = dateUtil.toMoment(actualCompDate.value).add(1, 'year').subtract(1, 'day').toDate()
        dlpDateFieldTools.setPendingField(targetDate)
      } else {
        dlpDateFieldTools.setPendingField(curDlpDate.value)
      }
    }
    const datePickerValue = computed(() => dateUtil.format(dlpDateFieldTools.pendingField.value))
    return {
      updateDatePickerValue,
      disableDlpdDate,
      dlpDateFieldTools,
      actualCompDate,
      curDlpDate,
      datePickerValue,
    }
  },
}
</script>
